import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
export function SignInButton({ googleConfigured, demoAllowed, label = "Sign in with Google", redirectTo = "/onboarding" }: {
  googleConfigured: boolean; demoAllowed: boolean; label?: string; redirectTo?: string;
}) {
  const { startGoogleSignIn, signInDemo } = useAuth();
  const navigate = useNavigate();
  const [pending, setPending] = useState(false);
  const [error, setError] = useState<string | null>(null);
  if (googleConfigured) {
    return (
      <div className="flex flex-col gap-2 md:inline-flex">
        <button type="button" disabled={pending} onClick={() => {
          setPending(true);
          setError(null);
          void startGoogleSignIn(redirectTo)
            .then(() => setPending(false))
            .catch((err: unknown) => {
              setError(err instanceof Error ? err.message : "Could not open Google.");
              setPending(false);
            });
        }}
          className="w-full rounded-2xl bg-teal-700 px-6 py-4 text-base font-semibold text-white shadow-lg shadow-teal-700/25 hover:bg-teal-800 disabled:opacity-60 md:w-auto">
          {pending ? "Opening Google…" : label}
        </button>
        {error ? <p className="text-sm text-red-600" role="alert">{error}</p> : null}
      </div>
    );
  }
  if (!demoAllowed) return <p className="text-sm text-amber-700">Sign-in is not configured yet.</p>;
  return (
    <div className="flex flex-col gap-2 md:inline-flex">
      <button type="button" disabled={pending} onClick={() => {
        setPending(true); setError(null);
        void signInDemo({ redirectTo }).then((next) => navigate(next)).catch((err: unknown) => {
          setError(err instanceof Error ? err.message : "Could not sign in."); setPending(false);
        });
      }} className="w-full rounded-2xl bg-teal-700 px-6 py-4 text-base font-semibold text-white shadow-lg shadow-teal-700/25 hover:bg-teal-800 disabled:opacity-60 md:w-auto">
        {pending ? "Signing in…" : `${label} (demo)`}
      </button>
      {error ? <p className="text-sm text-red-600" role="alert">{error}</p> : null}
    </div>
  );
}
